import { TreeDirectory } from '../types';

function collapseDirectoryPath(directory: TreeDirectory): string {
  const { contents } = directory;

  if (contents.length === 1 && contents[0].type === 'directory') {
    return `${directory.name}/${collapseDirectoryPath(
      contents[0] as TreeDirectory
    )}`;
  }

  return directory.name;
}
export default collapseDirectoryPath;
